import { Link } from 'react-router-dom';
import { Twitter, Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { label: 'Home', href: '/' },
    { label: 'Features', href: '/#features' },
    { label: 'Pricing', href: '/#pricing' },
    { label: 'Blog', href: '/blog' },
    { label: 'About', href: '/about' },
    { label: 'Login', href: 'https://app.searchefy.com/auth/login', external: true },
  ];

  const legalLinks = [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' },
  ];

  return (
    <footer className="footer py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <span className="font-display text-3xl font-black gradient-text">
                Searchefy
              </span>
            </Link>
            <p className="text-white/60 text-sm max-w-md mb-6">
              Systematic link building for serious growth. Build backlinks smarter with a curated directory of 500+ vetted sources and unlimited project tracking.
            </p>
            {/* Social links */}
            <div className="flex gap-4">
              <a
                href="https://twitter.com/searchefy"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-twitter"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/60 hover:text-white hover:bg-white/10 transition-all"
              >
                <Twitter size={18} />
              </a>
              <a
                href="https://linkedin.com/company/searchefy"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/60 hover:text-white hover:bg-white/10 transition-all"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-medium text-white mb-4">Navigation</h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  {link.external ? (
                    <a
                      href={link.href}
                      className="text-white/60 hover:text-white text-sm transition-colors"
                      data-testid={`footer-link-${link.label.toLowerCase()}`}
                    >
                      {link.label}
                    </a>
                  ) : link.href.startsWith('/#') ? (
                    <a
                      href={link.href}
                      className="text-white/60 hover:text-white text-sm transition-colors"
                      data-testid={`footer-link-${link.label.toLowerCase()}`}
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      to={link.href}
                      className="text-white/60 hover:text-white text-sm transition-colors"
                      data-testid={`footer-link-${link.label.toLowerCase()}`}
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-medium text-white mb-4">Legal</h4>
            <ul className="space-y-3">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-white/60 hover:text-white text-sm transition-colors"
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <span className="text-white/40 text-sm">
                  All sales final — No refunds
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {currentYear} Searchefy. Built by{' '}
            <a
              href="https://pratishjain.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-white transition-colors"
            >
              Pratish Jain
            </a>
            .
          </p>
          <a
            href="https://checkout.dodopayments.com/buy/pdt_0Nc1Sd7RjzAPh38CNHxE9?quantity=1"
            data-testid="footer-cta"
            className="btn-primary text-sm px-6 py-3"
          >
            Get Lifetime Access — $9
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
